import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { isTripOwner } from '@at/trip';
import { DatesEditStage, DatesSummary } from '../../entities';
import { CURRENT_TRIP } from '../../../../services';
import { DateRangePipe, StageTitlePipe } from '../../shared';

@Component({
  selector: 'at-dates-header',
  standalone: true,
  imports: [RouterLink, DateRangePipe, StageTitlePipe],
  templateUrl: './dates-header.component.html',
  styleUrl: './dates-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatesHeaderComponent {
  #trip = inject(CURRENT_TRIP);
  protected stage = computed(() => {
    const config = this.datesConfiguration();
    return config.state;
  });
  protected editLink = computed(() => {
    const editStage = this.editStage();
    if (!editStage) return undefined;

    return ['/', 'trip', this.#trip.tripId(), 'dates', 'edit', editStage];
  });
  protected isOwner = isTripOwner();

  public datesConfiguration = input.required<DatesSummary>();
  public editStage = input<DatesEditStage>('flow');
}
